import { Button } from "@/components/ui/button";
import {
  ChevronFirst,
  ChevronLast,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import { useTranslation } from "react-i18next";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  onPageChange: (page: number) => void;
}

export function Pagination({
  currentPage,
  totalPages,
  hasNextPage,
  hasPreviousPage,
  onPageChange,
}: PaginationProps) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-end space-x-2 py-4">
      <Button
        variant="outline"
        className="bg-[#A3F800] text-black rounded-full h-[40px] px-6"
        size="sm"
        onClick={() => onPageChange(1)}
        disabled={!hasPreviousPage}
      >
        <ChevronFirst className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="sm"
        className="bg-[#A3F800] text-black rounded-full h-[40px] px-6"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={!hasPreviousPage}
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <div className="text-sm text-black  font-bold p-2">
        {t("common.page")} {currentPage} {t("common.of")} {totalPages}
      </div>
      <Button
        variant="outline"
        size="sm"
        className="bg-primary-foreground text-primary rounded-full h-[40px] px-6"
        className="bg-[#A3F800] text-black rounded-full"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={!hasNextPage}
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="sm"
        className="bg-[#A3F800] text-black rounded-full h-[40px] px-6"
        onClick={() => onPageChange(totalPages)}
        disabled={!hasNextPage}
      >
        <ChevronLast className="h-4 w-4" />
      </Button>
    </div>
  );
}
